import { authTypes, generalTypes, socketTypes, teamTypes, participantTypes, inviteTypes } from '../actions'

const initialState = {
  loading: false,
  counter: 0,
  alert: '',
  schedules: {}
}

const general = (state = initialState, action) => {
  switch (action.type) {
    case authTypes.ATTEMPT:
      return { ...state, loading: true }
    case authTypes.RESPONSE:
      return { ...state, loading: false }
    case authTypes.FAIL:
      return { ...state, loading: false }
    case authTypes.LEAVE_HACKATHON:
      return { ...state, loading: true }
    case authTypes.LEAVE_RESPONSE:
      return { ...state, loading: false }
    case authTypes.SEND_ACTIVATION_CODE:
      return { ...state, loading: true }
    case authTypes.SEND_CODE_RES:
      return { ...state, loading: false }
    case socketTypes.CONNECT:
      return { ...state, loading: true }
    case socketTypes.SUCCESS:
      return { ...state, loading: false }
    case socketTypes.NEW_NOTIF:
      return { ...state, counter: state.counter + 1, alert: 'New notification recieved.' }
    case socketTypes.NEW_MSG:
      if (action.payload.msg.text.includes('@@all')) {
        return { ...state, counter: state.counter + 1, alert: 'You were mentioned in a chat message.' }
      } else {
        return state
      }
    case generalTypes.DISPLAY_ALERT:
      if (action.payload) {
        action = action.payload
      }
      return { ...state, counter: state.counter + 1, alert: action.text }
    case generalTypes.GET_INIT_DATA:
      return { ...state, loading: true }
    case generalTypes.INIT_DATA_RES:
      return { ...state, loading: false }
    case generalTypes.ADMIN_INIT:
      return { ...state, loading: true }
    case generalTypes.ADMIN_INIT_RES:
      return { ...state, loading: false }
    case generalTypes.SAVE_SCHEDULES:
      return { ...state, schedules: action.schedules }
    case teamTypes.REGISTER:
      return { ...state, loading: true }
    case teamTypes.REG_RESPONSE:
      return { ...state, loading: false }
    case teamTypes.MANAGE:
      return { ...state, loading: true }
    case teamTypes.MANAGE_RES:
      return { ...state, loading: false }
    case teamTypes.GET_MINE:
      return { ...state, loading: true }
    case teamTypes.GET_MINE_RESPONSE:
      return { ...state, loading: false }
    case teamTypes.GET_ALL:
      return { ...state, loading: true }
    case teamTypes.GET_ALL_RESPONSE:
      return { ...state, loading: false }
    case teamTypes.JOIN:
      return { ...state, loading: true }
    case teamTypes.JOIN_RESPONSE:
      return { ...state, loading: false }
    case teamTypes.DELETE:
      return { ...state, loading: true }
    case teamTypes.DELETE_RESPONSE:
      return { ...state, loading: false }
    case participantTypes.GET:
      return { ...state, loading: true }
    case participantTypes.GET_RESPONSE:
      return { ...state, loading: false }
    case participantTypes.MANAGE:
      return { ...state, loading: true }
    case participantTypes.CHANGE_LOCATION:
      return { ...state, loading: true }
    case participantTypes.CHANGE_LOCATION_RES:
      return { ...state, loading: false }
    case inviteTypes.EMAIL_INVITE:
      return { ...state, loading: true }
    case inviteTypes.EMAIL_INVITE_FAIL:
      return { ...state, loading: false }
    case inviteTypes.EMAIL_INVITE_SUCCESS:
      return { ...state, loading: false }
    default: return state
  }
}

export default general



// WEBPACK FOOTER //
// ./src/reducers/general.js